export default "__VITE_ASSET__CCCes5_C__"